import { useMutation } from 'react-query';
import axiosInstance from '@server/axiosInstance';
import { deleteCookie, setCookie } from '@utils/getCookie';
import { loginUserRoute } from '../api/constant';
import { toast } from 'react-toastify';

export const useLoginUser = () => {
    const { mutate: userLogin } =
        useMutation({
            mutationFn: (variables: {
                user_id: Number;
            }) =>
                axiosInstance
                    .get(`${loginUserRoute}${variables.user_id ? `?user_id=${variables.user_id}` : ''}`)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    deleteCookie('SU_AUTH')
                    deleteCookie('csrftoken')
                    deleteCookie('sessionid')
                    deleteCookie('dontShowWarningPopup')
                    deleteCookie('hideJobClosedSuggestion')
                    deleteCookie('SU_USER_TYPE')
                    deleteCookie('isNotificationPopupShown')
                    setCookie('isNotificationPopupShown', null, 0)
                    setCookie('dontShowWarningPopup', null, 0)
                    setCookie('hideJobClosedSuggestion', null, 0)
                    setCookie('SU_AUTH', data.token, 5);
                    setCookie('master_key', data.master_id, 5);
                    setCookie('csrftoken', data.csrf_token, 5);
                    setCookie('sessionid', data.session_id, 5);
                    setCookie('SU_USER_TYPE', data.user, 5);
                    if (data.user === 'applicant') {
                        window.location.href = '/applicants/';
                    } else if (data.user === 'company') {
                        window.location.href = '/dashboard/';
                    } else if (data.user === 'enterprise') {
                        window.location.href = '/enterprise/';
                    } else if (data.user === 'rockerbox') {
                        window.location.href = '/rockerbox/';
                    }
                } else if (data.status === 400) {
                    toast.error(data.message)
                }
            },
            onError: (error: { message?: string }) => {
                // Handle error
            },
        });
    return {
        userLogin,
    };
};
